import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface NavItemProps {
  to: string;
  icon: ReactNode;
  label: string;
  isActive?: (pathname: string) => boolean;
}

export function NavItem({ to, icon, label, isActive }: NavItemProps) {
  const location = useLocation();
  const active = isActive ? isActive(location.pathname) : location.pathname === to;

  return (
    <li className={active ? 'nav-item active' : 'nav-item'}>
      <NavLink to={to} className="nav-link">
        <span className="nav-link-icon d-md-none d-lg-inline-block">{icon}</span>
        <span className="nav-link-title"> {label} </span>
      </NavLink>
    </li>
  );
}
